import React from 'react';
import PropTypes from 'prop-types';
import Link from './link.js';
import {reisy, use} from 'reisy';
import DropdownItem from "../navigation/dropdown.js";
import {Button} from "../navigation/items.js";
import {ListItem} from './menu.js';


const style = reisy`
@namespace TagNav;

SelectionMode: multiple;
LinkMode: internal;

list {
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
}

tag {
	padding: 0 .5rem;
}

link {
	color: #999;
	text-decoration: none;

	&:hover {
		color: #333;
	}
}

listLink {
	@extends link;
}

listItem {
	@extends tag;
}
itemActive {

}

linkActive {
	@extends link;

	font-weight: bold;
	color: #111;
}


`;


const TagNav = ({tags, selected = [], active, options, allToggle}) => {
	if (!tags) { return null; }
	options = options || tags;
	const localSelected = [];
	const outerSelected = [];
	selected.forEach(t =>
		(tags.find(i => i.tags && i.tags.indexOf(t) !== -1)
			? localSelected
			: outerSelected).push(t)
		);
	if (!localSelected.length && options) {
		//localSelected.push(...options);
	}
	return (
		<ul {...use(style.list)}>
			{allToggle ? <li {...use(style.tag)} key="all">
				<Link {...use(!localSelected.length ? style.linkActive : style.link)} to={{query: {tags: outerSelected.join(',')}}} mode={style.LinkMode}>
					<span {...use(style.label)}>Alle</span>
				</Link>
			</li> : null}
			{tags.map((tag, i) => {
				if (tag.itemType && tag.itemType !== 'tagfilter') {
					const id = tag.to && tag.to.hierarchy && (tag.to.hierarchy.slice(-1)[0] || {}).id;
					let aa = (id && active === id);
					if (!aa) {
						if (tag.tags && tag.tags.length > 0 && selected && selected.length > 0) {
							for (const tt of tag.tags) {
								if (selected.indexOf(tt) >= 0) {
									aa = true;
									break;
								}
							}
						}
					}
					return (<ListItem styles={style} item={tag} active={aa} key={i} />);
				} else {
					let active = false;
					if (options.length) {
						active = tag.tags.every(t => ~localSelected.indexOf(t));
						if (active) { //click should remove item
							tag.to.query.tags = [...outerSelected, ...localSelected.filter(t => !~tag.tags.indexOf(t))].join(',');
						} else if (style.SelectionMode === 'multiple') { //click should add item to selected tags
							let combined = [...new Set([...tag.tags ,...selected])];
							if (options && options.every(t => ~combined.indexOf(t))) {
								tag.to.query.tags = combined.filter(t => !~options.indexOf(t)).join(',');
							} else {
								tag.to.query.tags = combined.join(',');
							}
						} else {
							tag.to.query.tags = tag.tags.join(',');
						}
					} else {
						tag.to.query.tags = tag.tags.join(',');
					}
					if (tag.to.query.tags === '') { tag.to.query.tags = null; }
					return (<li {...use(style.tag)} data-tag={tag.url} key={i}>
						<Link {...use(active ? style.linkActive : style.link)} to={tag.to} mode={style.LinkMode}>
							<span {...use(style.label)}>{tag.label}</span>
						</Link>
					</li>);
				}
			})}
		</ul>
	);
};

export default TagNav;

TagNav.propTypes = {
	tags: PropTypes.array,
};



// WEBPACK FOOTER //
// ./lib/components/tagnav.js